"use strict";

exports.__esModule = true;
exports.initConfig = void 0;

var _utils = require("./utils");

exports.getConfig = _utils.getConfig;
exports.__setConfig = _utils.__setConfig;
exports.setSsrConfig = _utils.setSsrConfig;
var initConfig = _utils.setSsrConfig;
exports.initConfig = initConfig;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/config-plugin/dist/index.js
// module id = 482
// module chunks = 11